import React from 'react';
import styles from './LoadingScreen.module.scss'

interface LoadingScreenProps {
    message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
    return (
        <div className={styles['tapps-loading']}>
            <div className={styles['tapps-loading-dots']}>
                <div className={styles['tapps-loading-dots-dot']}></div>
                <div className={styles['tapps-loading-dots-dot']}></div>
                <div className={styles['tapps-loading-dots-dot']}></div>
            </div>

            {
                message && 
                <div className={styles['tapps-loading-message']}>
                    { message }
                </div>
            }
        </div>
    );
};

export default LoadingScreen;
